module.exports = __webpack_public_path__ + "static/media/Avatars_Other-19.fb44e083.png";